import { Button as MuiButton, Card, CardContent, FormControl, Grid, TextField } from '@mui/material'
import { DownloadCloud } from 'react-feather'
import { Button } from 'reactstrap'

import { CustomAutocomplete } from 'common'

export const FormTransactionBank = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions,
        Helpers,
        defaultData,
    } = useFetchInit

    // ------------------------------------------------ Forms
    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen

    // ------------------------------------------------ FetchData
    const { fetchAllBanks } = FetchData
    const { banks } = fetchAllBanks
    const bancoNombre = banks.find(b => b.idbanco === formState.idbanco)?.nombre || ''

    // ------------------------------------------------ Helpers
    const { formatMoney } = Helpers

    // ------------------------------------------------ defaultData
    const { optionsAprobacionDeposit } = defaultData

    // ------------------------------------------------ Actions
    const { handleClickHideForm, handleClickDownloadBoleta, handleClickApproveDeposit } = Actions

    return (
        <div className='content'>
            <Card style={{ zIndex: '1' }}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>Informacion de Deposito</div>
                    <div className="border-bottom border-dark"></div>

                    <div className="pt-4"></div>

                    {/* ── Datos del deposito (solo lectura) ── */}
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="idbanco">Banco</label>
                                <TextField
                                    id="idbanco"
                                    name="idbanco"
                                    value={bancoNombre}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="origen">Origen</label>
                                <TextField
                                    id="origen"
                                    name="origen"
                                    value={formState.origen}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="fecha">Fecha</label>
                                <TextField
                                    id="fecha"
                                    name="fecha"
                                    value={formState.fecha}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-3"></div>

                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="monto">Monto</label>
                                <TextField
                                    id="monto"
                                    name="monto"
                                    value={formState.monto}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="moneda">Moneda</label>
                                <TextField
                                    id="moneda"
                                    name="moneda"
                                    value={formState.moneda}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="tipo_cambio">Tipo de Cambio</label>
                                <TextField
                                    id="tipo_cambio"
                                    name="tipo_cambio"
                                    value={formState.tipo_cambio}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-3"></div>

                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="quetzales">Total en Quetzales</label>
                                <TextField
                                    id="quetzales"
                                    name="quetzales"
                                    value={formState.quetzales ? `Q. ${formatMoney(formState.quetzales)}` : ''}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="dolares">Total en Dolares</label>
                                <TextField
                                    id="dolares"
                                    name="dolares"
                                    value={formState.dolares ? `$ ${formatMoney(formState.dolares)}` : ''}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-3"></div>

                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="boleta_numero">Boleta #</label>
                                <TextField
                                    id="boleta_numero"
                                    name="boleta_numero"
                                    value={formState.boleta_numero}
                                    size='small'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-3"></div>

                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl fullWidth>
                                <label htmlFor="observaciones">Observaciones del deposito</label>
                                <TextField
                                    id="observaciones"
                                    name="observaciones"
                                    value={formState.observaciones}
                                    size='small'
                                    multiline
                                    rows={2}
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* ── Seccion de aprobacion (editable) ── */}
                    <div className="pt-4"></div>
                    <div className='h5 mt-1 mb-1'>Aprobacion</div>
                    <div className="border-bottom border-dark"></div>
                    <div className="pt-3"></div>

                    <form onSubmit={handleClickApproveDeposit}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <FormControl fullWidth>
                                    <label>Boleta de Deposito</label>
                                    <MuiButton
                                        startIcon={<DownloadCloud />}
                                        color='success'
                                        variant='contained'
                                        onClick={() => handleClickDownloadBoleta(formState.boleta_foto_originalname, formState.boleta_foto_path)}
                                        disabled={!formState.boleta_foto_path}
                                        sx={{ textDecoration: 'none', paddingTop: 1 }}
                                    >
                                        Descargar
                                    </MuiButton>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={5} lg={5}>
                                <FormControl fullWidth>
                                    <label htmlFor="aprobacion_referencia_ach">No. Referencia ACH</label>
                                    <TextField
                                        id="aprobacion_referencia_ach"
                                        name="aprobacion_referencia_ach"
                                        value={formState.aprobacion_referencia_ach}
                                        onChange={onInputChange}
                                        size='small'
                                        variant='outlined'
                                        hiddenLabel
                                        placeholder='No. Referencia ACH'
                                        type='number'
                                        InputProps={{ readOnly: false }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={5} lg={5}>
                                <FormControl fullWidth>
                                    <label htmlFor="aprobacion_check">* Aprobacion</label>
                                    <CustomAutocomplete
                                        customId="aprobacion_check"
                                        customName="aprobacion_check"
                                        customValue={formState.aprobacion_check}
                                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'aprobacion_check', value: value.value } })}
                                        customPlaceholder='Seleccionar un modo'
                                        customOptions={
                                            optionsAprobacionDeposit.map(({ value, label }) => ({
                                                value,
                                                name: label
                                            }))
                                        }
                                        customDisableClearable={true}
                                        customDisabled={false}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <label htmlFor="aprobacion_observaciones">Observaciones</label>
                                    <TextField
                                        id="aprobacion_observaciones"
                                        name="aprobacion_observaciones"
                                        value={formState.aprobacion_observaciones}
                                        onChange={onInputChange}
                                        size='small'
                                        multiline
                                        rows={5}
                                        variant='outlined'
                                        hiddenLabel
                                        placeholder='Observaciones de aprobacion'
                                        InputProps={{ readOnly: false }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>

                        <Grid container>
                            <Grid item>
                                <MuiButton
                                    style={{ background: '#4b4b4c' }}
                                    variant='contained'
                                    type='submit'
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </MuiButton>
                                &nbsp;&nbsp;
                                <Button
                                    color='warning'
                                    type='button'
                                    onClick={handleClickHideForm}
                                >
                                    <i className="fa-regular fa-circle-left"></i> &nbsp; Volver
                                </Button>
                            </Grid>
                        </Grid>
                    </form>

                </CardContent>
            </Card>
        </div>
    )
}
